import { CanvasRectangle } from './cc-rect';

export class CCMosaicRect extends CanvasRectangle {
  constructor(
    id: number,
    x: number,
    y: number,
    width: number,
    height: number,
    public density: number,
    oneTime: boolean = false,
    scaleFactor?: number,
  ) {
    super(id, x, y, width, height, oneTime, scaleFactor);
  }
}
